import context from '../context'
import camelCase from 'lodash/camelCase'
import forOwn from 'lodash/forOwn'
import { actionCreators as localeActionCreators } from './Localize'

const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  resx: {},

  clearingCache: false
}

const actionTypes = {
  AllResourcesLoaded: 'localize/AllResourcesLoaded',
  LoadingAllResources: 'localize/LoadingAllResources',
  UpdateResource: 'localize/UpdateResource',
  ClearingCache: 'localize/ClearingCache',
  CacheCleared: 'localize/CacheCleared',
  Error: 'localize/error'
}

export const actionCreators = {
  loadResourcesForAllLocales: () => (dispatch) => {
    dispatch({ type: actionTypes.LoadingAllResources })
    const resx = {}
    context.api.localizationService.get('en').then(enData => {
      processData(resx, enData, 'en')
      return context.api.localizationService.get('ar').then(arData => {
        processData(resx, arData, 'ar')
        dispatch({ type: actionTypes.AllResourcesLoaded, data: resx })
      })
    }).catch(() => dispatch({ type: actionTypes.Error }))
  },
  updateResource: (resource) => (dispatch) => {
    context.api.localizationService.update(resource).then(response => {
      if (response === true) {
        dispatch({ type: actionTypes.UpdateResource, data: resource })
      } else {
        // dispatch action about error
      }
    }).catch(() => dispatch({ type: actionTypes.Error }))
  },
  reload: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.ClearingCache })
    context.api.localizationService.reload().then(() => {
      dispatch({ type: actionTypes.CacheCleared })
      dispatch(localeActionCreators.reloadResources(getState().localization.locale))
    }).catch(() => dispatch({ type: actionTypes.Error }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LoadingAllResources:
      state = { ...state, fetching: true }
      break
    case actionTypes.AllResourcesLoaded:
      state = { ...state, fetching: false, fetched: true, resx: action.data }
      break
    case actionTypes.ClearingCache:
      state = { ...state, clearingCache: true }
      break
    case actionTypes.CacheCleared:
      state = { ...state, clearingCache: false }
      break
    case actionTypes.UpdateResource:
      {
        const newResx = { ...state.resx }
        const { type, key, locale, value } = action.data
        newResx[camelCase(type)][camelCase(key)][locale] = value

        state = { ...state, resx: newResx }
      }
      break
    case actionTypes.Error:
      state = { ...state, fetching: false, clearingCache: false }
      break
    default: break
  }
  return state
}

export function processData (resx, response, language) {
  forOwn(response.data, (value, key) => {
    const parts = key.split(':')
    const resxName = camelCase(parts[0])
    const textKey = camelCase(parts[1])

    resx[resxName] = resx[resxName] || {}
    resx[resxName][textKey] = resx[resxName][textKey] || {}
    resx[resxName][textKey][language] = value
  })
}



// WEBPACK FOOTER //
// ./src/store/Resources.js